// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"button___1mStd"};